<div class="card kpi-secondary">
    <div class="card-body kpi-card">
        <h5 class="card-title">Taux propriétaires</h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- %</ng-container>
            <ng-container *ngIf="!preview">
                {{ favorite.ad_city.logement.T_PROP * 100| number: '1.1-1' }} %
            </ng-container>
        </p>
    </div>
</div>
